import React from 'react';
import styles from './landingFaq.module.css';

interface FaqTriggerProps {
  question: string;
  isOpen: boolean;
  onToggle: () => void;
}

const FaqTrigger: React.FC<FaqTriggerProps> = ({ question, isOpen, onToggle }) => (
  <button
    type="button"
    className={styles.faqTrigger}
    onClick={onToggle}
    aria-expanded={isOpen}
  >
    <span>{question}</span>
    <span className={styles.faqTriggerIcon} aria-hidden="true">
      {isOpen ? '−' : '+'}
    </span>
  </button>
);

export default FaqTrigger;
